import { UserRole } from "model/user/userRole";
import React from "react";
import {
    ChipField,
    List,
    Datagrid,
    TextField,
    ListProps,
    FilterProps,
    Filter,
    AutocompleteInput,
    TextInput,
    BulkDeleteButton,
    NullableBooleanInput,
    BooleanField,
    EmailField,
    ReferenceField, ReferenceInput, usePermissions,
} from "react-admin";
import UserDisableEnableButton from "reactAdmin/resource/user/button/userDisableEnableButton";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import LuxonUtils from "@date-io/luxon";
import UserResendInvitationButton from "reactAdmin/resource/user/button/userResendInvitationButton";
import { AdminResource } from "reactAdmin/resource/resource";
import UserField from "reactAdmin/resource/user/field/userField";
import { useTranslation } from "react-i18next";
import { Capability } from "reactAdmin/capabilities";

const BulkActions: React.FC<any> = (props) => {
    const { permissions: isAuthorized } = usePermissions();

    return (
        <React.Fragment>
            {isAuthorized && isAuthorized(Capability.DISABLE_USER) && (<UserDisableEnableButton {...props} />)}
            {isAuthorized && isAuthorized(Capability.ENABLE_USER) && (<UserDisableEnableButton enable={false} {...props} />)}
            <UserResendInvitationButton {...props} />
            {isAuthorized && isAuthorized(Capability.DELETE_USER) && (<BulkDeleteButton {...props} />)}
        </React.Fragment>
    );
}

const UserFilter = (props: Partial<FilterProps>) => {
  const { t } = useTranslation();
  return (
    <MuiPickersUtilsProvider utils={LuxonUtils}>
      <Filter {...props}>
        <ReferenceInput label={t("resource.user")} source="id" reference={AdminResource.users} filterToQuery={searchText => ({ displayName: [searchText] })} alwaysOn>
          <AutocompleteInput optionText="displayName"/>
        </ReferenceInput>
        <TextInput source="firstName" />
        <TextInput source="lastName" />
        <TextInput source="emailAddress" />
        <AutocompleteInput
          source="role"
          choices={Object.values(UserRole).map((item) => ({
            id: item,
            name: item,
          }))}
        />
        <NullableBooleanInput source="isDisabled" />
        <ReferenceInput label={t("resource.organization")} source="organizationId" reference={AdminResource.organizations} filterToQuery={searchText => ({ name: [searchText] })}>
          <AutocompleteInput optionText="name"/>
        </ReferenceInput>
      </Filter>
    </MuiPickersUtilsProvider>
  );
};

export const UserList = (props: ListProps) => {
    const { t } = useTranslation();

    return (
        <List
            filters={<UserFilter />}
            {...props}
            bulkActionButtons={<BulkActions />}
            exporter={false}
        >
            <Datagrid rowClick="edit">
                <TextField source="id" />
                <UserField source="displayName" avatar="avatar.src" label={t('userList.name')} />
                <EmailField source="emailAddress" />
                <ChipField source="role" size="small" />
                <BooleanField source="isDisabled" />
                <ReferenceField label={t('resource.organization')} source="organizationId" reference={AdminResource.organizations} sortable={false}>
                    <TextField source="name" />
                </ReferenceField>
            </Datagrid>
        </List>
    );
}
